import cookie from 'cookie';
import { redirect } from 'widgets/I18nLink';
import { defaultGetAction, defaultCreateAction } from 'utils/redux';

import {
  GET_PROFILE,
  DATA_CLEAR_PROFILE,
  POST_REGISTER_USER,
  POST_RESTORE_PASSWORD,
  PUT_RESTORE_PASSWORD
} from '../constants';

export function login(data, redirectTo) {
  return dispatch => {
    return fetch('/api/session-auth/login/?next=/api/accounts/current/', {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'manual'
    }).then(() => {
      const csrf = cookie.parse(document.cookie).csrftoken;
      if (!csrf) {return Promise.resolve(null);}

      Object.assign(data, { csrfmiddlewaretoken: csrf });
      const body = Object.keys(data).map(k => `${k}=${data[k]}`).join('&');

      return fetch('/api/session-auth/login/?next=/api/accounts/current/', {
        method: 'POST',
        credentials: 'same-origin',
        redirect: 'manual',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body
      });
    }).then(() => {
      return dispatch(loadProfile())
        .then(action => {
          if (action.response) {
            redirect(redirectTo || '/profile/');
          }

          return action;
        });
    });
  };
}

export const loadProfile = defaultGetAction(GET_PROFILE, 'accounts/current/');

export function logout() {
  return dispatch => {
    return fetch('/api/session-auth/logout/', {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'manual'
    }).then(() => dispatch({ type: DATA_CLEAR_PROFILE }));
  };
}

export function registerUser(data) {
  return dispatch => dispatch({
    type: POST_REGISTER_USER,
    meta: {
      method: 'POST',
      endpoint: 'accounts/register/',
      data
    }
  })
  .then(action => {
    if (action.response) {
      dispatch(login({ username: data.email, password: data.password }));
    }

    return action;
  });
}

export const restorePassword = defaultCreateAction(POST_RESTORE_PASSWORD, 'accounts/restore_password/');

export function updatePassword(data) {
  return dispatch => dispatch({
    type: PUT_RESTORE_PASSWORD,
    meta: {
      method: 'PUT',
      endpoint: 'accounts/restore_password/restore/',
      data
    }
  });
}



// WEBPACK FOOTER //
// ./src/actions/auth.js